import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor } from '@ezugi/ui/theme';

const minStacksContainerWidth = 38;
const diceSize = 24;

export const TotalValue = styled.span`
  width: ${diceSize}px;
  height: ${diceSize}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DiceValue = styled.span`
  width: ${diceSize}px;
  height: ${diceSize}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.3);

  &.triple {
    color: #fff;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 2px;

  background: ${getThemeColor('primary')};
  align-items: center;
  font-weight: bold;
  font-size: 12px;
  padding: 2px;
  border: 2px solid #3f425d;
  border-radius: 6px;
  line-height: normal;

  &.small {
    ${TotalValue} {
      color: #fff;
    }
  }

  &.big {
    ${TotalValue} {
      color: #1db0fa;
    }
  }

  &.triple {
    border-color: #d2413c;
    color: #fff;

    ${DiceValue} {
      border-color: rgba(255, 255, 255, 0.1);
      background-color: rgba(255, 37, 47, 0.65);
    }

    ${TotalValue} {
      color: #d2413c;
    }
  }

  &:first-child {
    border-color: #ffb300;
  }
`;

export const mobileContainerClassName = css`
  ${DiceValue}, ${TotalValue} {
    height: auto;
  }
`;

export const StacksContainer = styled.div`
  margin-top: 4px;
  display: grid;
  grid-template-columns: repeat(
    ${(props) => props.columns},
    minmax(${minStacksContainerWidth}px, 1fr)
  );
  grid-column-gap: 0px;
  grid-row-gap: 4px;

  > div {
    margin: 0 2px;
  }
`;

export const toggleSelectClassName = css`
  width: 100%;
`;

export const mobileClassName = css`
  z-index: -1;
  @media all and (orientation: landscape) {
    grid-template-columns: repeat(
      auto-fill,
      minmax(${minStacksContainerWidth}px, 1fr)
    );
    align-self: start;
  }
`;

export const verticalClassName = css`
  display: block;
  z-index: -1;
  width: auto;
  height: 24px;
  overflow: hidden;
  margin: 0;
  transform: unset;
  white-space: nowrap;
  box-sizing: content-box;
  padding: 5px 0 0 0;

  @media all and (orientation: portrait) {
    padding: 5px 0;
    display: block;
    position: absolute;
    bottom: 0;
    top: unset;
    right: unset;
    transform: unset;
  }

  @media all and (orientation: landscape) {
    padding: 5px 0;
    display: block;
    position: absolute;
    width: 100%;
    bottom: 0;
    top: unset;
    right: unset;
    transform: unset;
  }

  ${Container}, ${TotalValue}, ${DiceValue} {
    display: inline-block;
    width: auto;
  }

  ${TotalValue}, ${DiceValue} {
    padding: 0 2px;
    &:after {
      content: unset;
      display: unset;
      padding-bottom: unset;
    }
  }

  ${Container} {
    min-width: 70px;

    &.small,
    &.big,
    &.triple {
      ${TotalValue} {
        color: #fff;
        width: 40%;
      }
    }

    &.triple {
      border-color: #d2413c;
      ${DiceValue} {
        color: #d2413c;
        background-color: unset;
      }
    }

    &:first-child {
      border-color: #ffb300;
    }
  }

  ${DiceValue} {
    border: unset;
    background: unset;
  }

  ${DiceValue}:last-of-type {
    width: 15%;
  }
`;

export const singleDigitClassName = css`
  text-align: center;
`;
